// Hirá: product card add to cart states.
// Shows "Added" only once Shopify confirms the add, and a short message if it fails
// (Horizon plays its animation on click, before the cart has answered).
(() => {
  const ADDED_MS = 1600;
  const ERROR_MS = 2600;
  const timers = new WeakMap();

  const cardButton = (event) => {
    const card = event.target instanceof Element ? event.target.closest('product-card') : null;
    return card ? card.querySelector('.quick-add__button--add') : null;
  };

  const setState = (button, state, holdMs) => {
    clearTimeout(timers.get(button));
    button.dataset.hiraState = state;
    timers.set(button, setTimeout(() => delete button.dataset.hiraState, holdMs));
  };

  const errorLabel = (button) => {
    let label = button.querySelector('.hira-qa__error');
    if (!label) {
      label = document.createElement('span');
      label.className = 'hira-qa__error';
      label.setAttribute('aria-hidden', 'true');
      button.append(label);
    }
    return label;
  };

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const button = cardButton(event);
    if (!button || !event.promise) return;

    event.promise
      .then((result) => {
        if (result?.detail?.didError) {
          setState(button, 'error', ERROR_MS);
        } else {
          setState(button, 'added', ADDED_MS);
        }
      })
      .catch(() => setState(button, 'error', ERROR_MS));
  });

  document.addEventListener('shopify:cart:error', (event) => {
    const button = cardButton(event);
    if (!button) return;

    const message = String(event.error || '');
    errorLabel(button).textContent = /maximum/i.test(message) ? 'Max already in your cart' : 'Couldn’t add, try again';
  });
})();
